export const ACCOUNT_TYPE = {
    STUDENT: "Student",
    LIBRARIAN: "Librarian",
    ADMIN: "Admin",
  }
  